const topics = [
  { label: '韩漫腐完结推荐', icon: 'ri-bookmark-line', heat: '9.8w 热度', tag: '热门', tagColor: 'bg-accent-100 text-accent-800' },
  { label: '日漫腐新连载', icon: 'ri-sun-line', heat: '7.2w 热度', tag: '新番', tagColor: 'bg-primary-100 text-primary-700' },
  { label: '国漫耽美古风', icon: 'ri-brush-line', heat: '6.5w 热度', tag: '古风', tagColor: 'bg-secondary-100 text-secondary-800' },
  { label: '校园纯爱系列', icon: 'ri-hearts-line', heat: '8.1w 热度', tag: '纯爱', tagColor: 'bg-accent-100 text-accent-800' },
  { label: '奇幻异世界BL', icon: 'ri-magic-line', heat: '5.6w 热度', tag: '奇幻', tagColor: 'bg-primary-100 text-primary-700' },
  { label: '悬疑推理耽美', icon: 'ri-search-eye-line', heat: '4.9w 热度', tag: '悬疑', tagColor: 'bg-secondary-100 text-secondary-800' },
  { label: '霸道总裁系列', icon: 'ri-vip-crown-line', heat: '7.8w 热度', tag: '总裁', tagColor: 'bg-accent-100 text-accent-800' },
  { label: '年下攻推荐', icon: 'ri-user-heart-line', heat: '6.3w 热度', tag: '年下', tagColor: 'bg-primary-100 text-primary-700' },
  { label: 'ABO世界观', icon: 'ri-planet-line', heat: '5.4w 热度', tag: 'ABO', tagColor: 'bg-secondary-100 text-secondary-800' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">大家都在讨论的腐漫话题与标签</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.label}
              href="#topics"
              className="group flex items-center gap-2.5 px-4 py-3 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50 text-foreground-600 group-hover:text-primary-600 transition-colors">
                <i className={`${topic.icon} text-base`}></i>
              </span>
              <div className="text-left">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{topic.label}</span>
                  <span className={`inline-block px-1.5 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${topic.tagColor}`}>
                    {topic.tag}
                  </span>
                </div>
                <span className="text-xs text-foreground-400">{topic.heat}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}